export default "__VITE_ASSET__D8KQ2$Fi__"